<template>
  <v-container>
    <h1>{{ $store.getters.sourceDictionaryName }} / Sections</h1>
    <SectionsTable v-on:edit="edit($event)"></SectionsTable>
    <SectionDialog v-model="dialog" :model="model"></SectionDialog>
    <v-btn
            fixed
            dark
            fab
            right
            bottom
            color="pink"
            v-on:click="create()"
    >
      <v-icon>add</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import SectionsTable from '../components/SectionsTable'
import SectionDialog from '../components/SectionDialog'

export default {
  components: { SectionDialog, SectionsTable },
  data () {
    return {
      model: null,
      dialog: false
    }
  },
  methods: {
    create () {
      this.model = null
      this.dialog = true
    },
    edit (model) {
      this.model = model
      this.dialog = true
    }
  }
}
</script>
